import TextCardList from './TextCardList';
import { TextCardListProps, TextCardListValueProps } from './types';

export type { TextCardListProps, TextCardListValueProps };
export default TextCardList;
